const plugin = require('tailwindcss/plugin');
const values = require('lodash/values');
const flattenDeep = require('lodash/flattenDeep');
const {colorTheme} = require('../../src/common/shared/theme/colorTheme');

const innerBorderColorUtils = plugin(function ({addUtilities}) {
  addUtilities(
    flattenDeep(values(colorTheme)).map(({tw, color}) => {
      return {
        [`.inner-line-${tw}`]: {
          '&::after': {
            '--inner-line-color': color,
          },
        },
      };
    })
  );
});

module.exports = innerBorderColorUtils;
